import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
//#region src/tooltip/Tooltip.tsx
const TooltipProvider = TooltipPrimitive.Provider;
const TooltipPortal = TooltipPrimitive.Portal;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = ({ onClick: onClickConsumer, className, ...props }) => {
	const onClick = (e) => {
		if (onClickConsumer) {
			e.preventDefault();
			onClickConsumer(e);
		}
	};
	return /* @__PURE__ */ jsx(TooltipPrimitive.TooltipContent, {
		className: twMerge(`z-pentOutermost max-w-56 rounded-xl bg-black px-3 py-2 text-center text-xs text-white`, className),
		onClick,
		...props
	});
};
const TooltipArrow = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(TooltipPrimitive.Arrow, {
		className: twMerge(`z-pentOutermost fill-black`, className),
		...props
	});
};
const Provider = TooltipProvider;
const Portal = TooltipPortal;
const Root = Tooltip;
const Trigger = TooltipTrigger;
const Content = TooltipContent;
const Arrow = TooltipArrow;
//#endregion
export { Arrow, Content, Portal, Provider, Root, Tooltip, TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger, Trigger };
